import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

function _successHeading(status) {
  if (status === "active") return "You're subscribed!";
  if (status === "polling") return "Confirming payment…";
  return "Payment status";
}

function _successBody(status, plan) {
  if (status === "active") return `Welcome to the ${plan} plan. Your generation counter has been reset.`;
  if (status === "polling") return "This usually takes a few seconds.";
  return "If your card was charged but you don't see Active, please contact support.";
}

export default function TutorSuccess() {
  const [sp] = useSearchParams();
  const sessionId = sp.get("session_id");
  const [status, setStatus] = useState("polling");
  const [plan, setPlan] = useState("");

  useEffect(() => {
    if (!sessionId) return;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/api/tutor/subscribe/status/${sessionId}`);
        if (data.status === "active") { setStatus("active"); setPlan(data.plan); return; }
        if (data.payment_status === "expired") { setStatus("expired"); return; }
      } catch (err) {
        console.warn("stripe subscription status poll retry", err?.message || err);
        // retry below
      }
      if (++tries < 10) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="max-w-xl mx-auto px-6 py-16 text-center" data-testid="tutor-success">
      <div className="bg-white border border-[#E5E7EB] rounded-2xl p-8">
        <CheckCircle2 className="w-12 h-12 text-[#064E3B] mx-auto" />
        <h1 className="font-display font-black text-3xl mt-3">
          {_successHeading(status)}
        </h1>
        <p className="text-sm text-[#4B5563] mt-2">
          {_successBody(status, plan)}
        </p>
        <Link to="/tutor" data-testid="success-back" className="btn-primary inline-block mt-6">
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
